module.exports = __webpack_public_path__ + "302cac717aa088fe8a882565f1353352.MP3";